import React from 'react'
import Card from '../card/Card'
import VehiclesForm from './VehiclesForm'

const Vehicles = () => {
  return (
    <Card component={<VehiclesForm /> } title={'Registrar Vehículo'}/>
  )
}

export default Vehicles